import { useState, useEffect } from 'react';
import { produtosService, categoriasService, estoqueService, fichasService, configService } from '../../services';
import { formatCurrency } from '../../utils/format';
import './CardapioAdmin.css';

function calcMargem(preco, custo, taxa) {
  const p = parseFloat(preco);
  const c = parseFloat(custo);
  const t = parseFloat(taxa) || 0;
  if (!p || p <= 0) return null;
  const liquido = p * (1 - t / 100);
  return ((liquido - c) / liquido * 100).toFixed(1);
}

function calcPrecoSugerido(custo, margem, taxa) {
  const c = parseFloat(custo);
  const m = parseFloat(margem) / 100;
  const t = parseFloat(taxa) / 100;
  if (!c || m >= 1 || t >= 1) return null;
  return c / ((1 - t) * (1 - m));
}

const TIPO_LABEL = { nenhum: '—', revenda: '📦 Revenda', fabricado: '🔧 Fabricado' };
const TIPO_COLOR = { nenhum: '#aaa', revenda: '#1a6bb5', fabricado: '#6b21a8' };

const EMOJIS_RESTAURANTE = [
  '🥟','🍕','🍔','🌮','🌯','🥙','🍣','🍜','🍝','🍲','🥘','🫕',
  '🍗','🍖','🥩','🥚','🍳','🧆','🥗','🥪','🫔','🍱','🥡','🍛',
  '🍤','🦐','🦑','🦞','🦀','🐟','🍟','🌭','🧇','🥞','🧈',
  '🫓','🥨','🧀','🥓','🍠','🥔','🍆','🥦','🥕','🌽','🍅',
  '🍰','🎂','🧁','🍮','🍭','🍬','🍫','🍩','🍪','🍦','🧃',
  '🥤','🧋','☕','🍵','🍺','🍻','🥂','🍷','🍸','🍹','🧉',
  '🍾','🥃','🫖','🧊','🍽️','🥄','🍴','🫙','🧂',
];

function EmojiPicker({ value, onChange }) {
  const [aberto, setAberto] = useState(false);
  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        onClick={() => setAberto(a => !a)}
        style={{
          width: 48, height: 40, fontSize: 22, cursor: 'pointer',
          border: '2px solid var(--gray)', borderRadius: 'var(--radius)',
          background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
        title="Selecionar emoji"
      >
        {value || '🥟'}
      </button>
      {aberto && (
        <>
          <div onClick={() => setAberto(false)} style={{ position: 'fixed', inset: 0, zIndex: 99 }} />
          <div style={{
            position: 'absolute', top: '100%', left: 0, zIndex: 100,
            background: '#fff', border: '2px solid var(--gray)', borderRadius: 'var(--radius)',
            padding: 8, display: 'flex', flexWrap: 'wrap', gap: 2,
            width: 240, maxHeight: 200, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,.15)',
          }}>
            {EMOJIS_RESTAURANTE.map(e => (
              <button
                key={e} type="button"
                onClick={() => { onChange(e); setAberto(false); }}
                style={{
                  fontSize: 20, background: e === value ? '#f0f4ff' : 'none',
                  border: e === value ? '2px solid var(--primary)' : '2px solid transparent',
                  borderRadius: 6, cursor: 'pointer', padding: 2, lineHeight: 1,
                }}
              >
                {e}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default function CardapioAdmin() {
  const [produtos, setProdutos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [insumos, setInsumos] = useState([]);
  const [taxas, setTaxas] = useState([]);
  const [margemAlvo, setMargemAlvo] = useState('50');
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // null | 'novo' | <produto_id>
  const [fichaModal, setFichaModal] = useState(null); // produto object | null
  const [fichaItems, setFichaItems] = useState([]); // [{insumo_id, quantidade}]
  const [fichaLoading, setFichaLoading] = useState(false);
  const [form, setForm] = useState({
    nome: '', descricao: '', emoji: '', categoria_id: '', preco: '', custo: '',
    tags: '', status: 'ativo', tipo_estoque: 'nenhum', insumo_id: '', exibir_cardapio: true,
  });
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');

  // Gestão de categorias do cardápio
  const [modalCat, setModalCat] = useState(false);
  const [erroCat, setErroCat] = useState('');
  const [catForm, setCatForm] = useState({ nome: '', emoji: '', ordem: '' });
  const [catEditId, setCatEditId] = useState(null);
  const [catEdit, setCatEdit] = useState({ nome: '', emoji: '', ordem: '', ativa: true });

  const carregar = async () => {
    setLoading(true);
    try {
      const [p, c, ins, tax] = await Promise.all([
        produtosService.listar(),
        categoriasService.listar(),
        estoqueService.listar(),
        configService.taxasCartao(),
      ]);
      setProdutos(p.data);
      setCategorias(c.data);
      setInsumos(ins.data);
      setTaxas(Array.isArray(tax.data) ? tax.data : []);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => {
    setErro('');
    setForm({ nome: '', descricao: '', emoji: '', categoria_id: categorias[0]?.id || '', preco: '', custo: '', tags: '', status: 'ativo', tipo_estoque: 'revenda', insumo_id: '', exibir_cardapio: true });
    setModal('novo');
  };

  const abrirEditar = (p) => {
    setForm({
      nome: p.nome, descricao: p.descricao || '', emoji: p.emoji || '',
      categoria_id: p.categoria_id, preco: p.preco, custo: p.custo || '',
      tags: p.tags || '', status: p.status,
      tipo_estoque: p.tipo_estoque || 'nenhum',
      insumo_id: p.insumo_id || '',
      exibir_cardapio: p.exibir_cardapio !== 0,
    });
    setModal(p.id);
  };

  // ---- Categorias ----
  const abrirCategorias = () => {
    setErroCat('');
    setCatForm({ nome: '', emoji: '', ordem: '' });
    setCatEditId(null);
    setModalCat(true);
  };

  const salvarNovaCategoria = async (e) => {
    e.preventDefault();
    setErroCat('');
    try {
      await categoriasService.criar({
        nome: catForm.nome.trim(),
        emoji: catForm.emoji || null,
        ordem: catForm.ordem ? Number(catForm.ordem) : 0,
      });
      setCatForm({ nome: '', emoji: '', ordem: '' });
      const c = await categoriasService.listar();
      setCategorias(c.data);
    } catch (err) {
      setErroCat(err.response?.data?.error || 'Erro ao criar categoria.');
    }
  };

  const iniciarEdicaoCategoria = (c) => {
    setErroCat('');
    setCatEditId(c.id);
    setCatEdit({ nome: c.nome, emoji: c.emoji || '', ordem: c.ordem ?? '', ativa: c.ativa !== 0 });
  };

  const salvarEdicaoCategoria = async (e) => {
    e.preventDefault();
    setErroCat('');
    try {
      await categoriasService.atualizar(catEditId, {
        nome: catEdit.nome.trim(),
        emoji: catEdit.emoji || null,
        ordem: catEdit.ordem ? Number(catEdit.ordem) : 0,
        ativa: catEdit.ativa,
      });
      setCatEditId(null);
      const c = await categoriasService.listar();
      setCategorias(c.data);
    } catch (err) {
      setErroCat(err.response?.data?.error || 'Erro ao atualizar categoria.');
    }
  };

  const removerCategoria = async (c) => {
    if (!window.confirm(`Remover a categoria "${c.nome}"?`)) return;
    setErroCat('');
    try {
      await categoriasService.remover(c.id);
      const res = await categoriasService.listar();
      setCategorias(res.data);
    } catch (err) {
      setErroCat(err.response?.data?.error || 'Erro ao remover categoria.');
    }
  };

  const salvar = async (e) => {
    e.preventDefault();
    setErro('');
    try {
      if (modal === 'novo') {
        await produtosService.criar(form);
      } else {
        await produtosService.atualizar(modal, form);
      }
      setModal(null);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao salvar produto. Verifique o console.');
      console.error('Erro salvar produto:', err.response?.data || err.message);
    }
  };

  const abrirFicha = async (produto) => {
    setFichaModal(produto);
    setFichaLoading(true);
    try {
      const res = await fichasService.buscar(produto.id);
      setFichaItems(res.data ? res.data.itens.map(i => ({ insumo_id: String(i.insumo_id), quantidade: String(i.quantidade) })) : []);
    } catch {
      setFichaItems([]);
    }
    setFichaLoading(false);
  };

  const adicionarLinhaFicha = () => {
    setFichaItems([...fichaItems, { insumo_id: '', quantidade: '' }]);
  };

  const atualizarLinhaFicha = (idx, campo, valor) => {
    const novo = fichaItems.map((it, i) => i === idx ? { ...it, [campo]: valor } : it);
    setFichaItems(novo);
  };

  const removerLinhaFicha = (idx) => {
    setFichaItems(fichaItems.filter((_, i) => i !== idx));
  };

  const salvarFicha = async (e) => {
    e.preventDefault();
    const itensValidos = fichaItems.filter(it => it.insumo_id && it.quantidade > 0);
    try {
      await fichasService.salvar({ produto_id: fichaModal.id, itens: itensValidos });
      setFichaModal(null);
      carregar();
    } catch {}
  };

  // Calcular custo total da ficha a partir dos insumos selecionados
  const custoFicha = fichaItems.reduce((soma, it) => {
    const ins = insumos.find(i => String(i.id) === String(it.insumo_id));
    if (!ins || !it.quantidade) return soma;
    return soma + parseFloat(ins.custo_unitario) * parseFloat(it.quantidade);
  }, 0);

  const produtosFiltrados = produtos.filter(p => {
    const matchBusca = !busca || p.nome.toLowerCase().includes(busca.toLowerCase()) || (p.tags || '').toLowerCase().includes(busca.toLowerCase());
    const matchCategoria = !filtroCategoria || String(p.categoria_id) === String(filtroCategoria);
    const matchStatus = !filtroStatus || p.status === filtroStatus;
    return matchBusca && matchCategoria && matchStatus;
  });

  return (
    <div className="cardapio-admin">
      <div className="page-header">
        <h1>📋 Cardápio - Produtos</h1>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn btn-outline" onClick={abrirCategorias}>⚙ Categorias</button>
          <button className="btn btn-primary" onClick={abrirNovo}>+ Novo Produto</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="🔍 Buscar por nome ou tag..."
          value={busca}
          onChange={e => setBusca(e.target.value)}
          style={{ flex: 1, minWidth: 200, padding: '7px 12px', border: '2px solid var(--gray)', borderRadius: 'var(--radius)' }}
        />
        <select
          value={filtroCategoria}
          onChange={e => setFiltroCategoria(e.target.value)}
          style={{ padding: '7px 12px', border: '2px solid var(--gray)', borderRadius: 'var(--radius)' }}
        >
          <option value="">Todas as categorias</option>
          {categorias.map(c => <option key={c.id} value={c.id}>{c.emoji} {c.nome}</option>)}
        </select>
        <select
          value={filtroStatus}
          onChange={e => setFiltroStatus(e.target.value)}
          style={{ padding: '7px 12px', border: '2px solid var(--gray)', borderRadius: 'var(--radius)' }}
        >
          <option value="">Todos os status</option>
          <option value="ativo">✅ Ativo</option>
          <option value="inativo">❌ Inativo</option>
        </select>
        {(busca || filtroCategoria || filtroStatus) && (
          <button className="btn btn-outline" onClick={() => { setBusca(''); setFiltroCategoria(''); setFiltroStatus(''); }}>
            Limpar filtros
          </button>
        )}
      </div>

      {loading ? (
        <div className="loading"><div className="spinner"></div>Carregando...</div>
      ) : (
        <div className="table-container card">
          <table>
            <thead>
              <tr>
                <th>Produto</th>
                <th>Categoria</th>
                <th>Preço</th>
                <th>Custo</th>
                <th>Margem</th>
                <th>Estoque</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {produtosFiltrados.length === 0 && (
                <tr><td colSpan="8" className="no-data">Nenhum produto encontrado</td></tr>
              )}
              {produtosFiltrados.map(p => (
                <tr key={p.id}>
                  <td>
                    <span className="produto-nome">{p.emoji} {p.nome}</span>
                    {p.exibir_cardapio === 0 && (
                      <span className="badge badge-secondary" style={{ marginLeft: 6, fontSize: 10 }} title="Produto interno — não aparece no cardápio público">🚫 Oculto</span>
                    )}
                  </td>
                  <td>{p.categoria_emoji} {p.categoria_nome}</td>
                  <td><strong>{formatCurrency(p.preco)}</strong></td>
                  <td>{formatCurrency(p.custo)}</td>
                  <td><span className={`badge ${parseFloat(p.margem) >= 50 ? 'badge-success' : 'badge-warning'}`}>{p.margem}%</span></td>
                  <td>
                    <span style={{ fontSize: 12, fontWeight: 600, color: TIPO_COLOR[p.tipo_estoque || 'nenhum'] }}>
                      {TIPO_LABEL[p.tipo_estoque || 'nenhum']}
                    </span>
                  </td>
                  <td><span className={`badge ${p.status === 'ativo' ? 'badge-success' : 'badge-danger'}`}>{p.status}</span></td>
                  <td className="acoes">
                    {p.tipo_estoque === 'fabricado' && (
                      <button className="btn btn-sm" style={{background:'#f3e8ff', color:'#6b21a8', border:'1px solid #c4b5fd', marginRight:4}} onClick={() => abrirFicha(p)} title="Ficha Técnica">
                        🔬 Ficha
                      </button>
                    )}
                    <button className="btn btn-sm btn-secondary" onClick={() => abrirEditar(p)}>✏️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal Produto */}
      {modal !== null && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>{modal === 'novo' ? 'Novo Produto' : 'Editar Produto'}</h2>
            <form onSubmit={salvar}>
              {erro && <div className="alert alert-danger">{erro}</div>}
              <div className="form-row">
                <div className="form-group">
                  <label>Nome</label>
                  <input value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} required />
                </div>
                <div className="form-group" style={{width: 80}}>
                  <label>Emoji</label>
                  <EmojiPicker value={form.emoji} onChange={v => setForm({...form, emoji: v})} />
                </div>
              </div>
              <div className="form-group">
                <label>Descrição</label>
                <textarea value={form.descricao} onChange={e => setForm({...form, descricao: e.target.value})} rows={2} />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Categoria</label>
                  <select value={form.categoria_id} onChange={e => setForm({...form, categoria_id: e.target.value})} required>
                    {categorias.map(c => <option key={c.id} value={c.id}>{c.emoji} {c.nome}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Status</label>
                  <select value={form.status} onChange={e => setForm({...form, status: e.target.value})}>
                    <option value="ativo">Ativo</option>
                    <option value="pausado">Pausado</option>
                    <option value="inativo">Inativo</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Preço (R$)</label>
                  <input type="number" step="0.01" value={form.preco} onChange={e => setForm({...form, preco: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Custo (R$)</label>
                  <input type="number" step="0.01" value={form.custo} onChange={e => setForm({...form, custo: e.target.value})} />
                </div>
              </div>

              {/* Simulador de margem por forma de pagamento */}
              {(parseFloat(form.preco) > 0 || parseFloat(form.custo) > 0) && (
                <div style={{background:'#f8f9fa', border:'1px solid #e8e8e8', borderRadius:10, padding:'12px 14px', marginBottom:16}}>
                  <div style={{fontWeight:700, fontSize:13, color:'#555', marginBottom:10}}>📊 Simulador de margem</div>
                  <table style={{width:'100%', fontSize:12, borderCollapse:'collapse'}}>
                    <thead>
                      <tr style={{color:'#888', borderBottom:'1px solid #eee'}}>
                        <th style={{textAlign:'left', paddingBottom:6}}>Forma</th>
                        <th style={{textAlign:'center', paddingBottom:6}}>Taxa</th>
                        <th style={{textAlign:'right', paddingBottom:6}}>Margem real</th>
                        <th style={{textAlign:'right', paddingBottom:6}}>Valor líquido</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { label: 'Dinheiro', taxa: 0, icon: '💵' },
                        ...taxas.map(t => ({ label: t.nome, taxa: parseFloat(t.taxa) || 0, icon: '💳' })),
                      ].map(({ label, taxa, icon }, idx) => {
                        const m = calcMargem(form.preco, form.custo, taxa);
                        const liquido = form.preco ? parseFloat(form.preco) * (1 - taxa / 100) : null;
                        const cor = m === null ? '#aaa' : parseFloat(m) >= 50 ? '#27ae60' : parseFloat(m) >= 30 ? '#f39c12' : '#e74c3c';
                        return (
                          <tr key={idx} style={{borderBottom:'1px solid #f5f5f5'}}>
                            <td style={{padding:'5px 0'}}>{icon} {label}</td>
                            <td style={{textAlign:'center', color:'#888'}}>{taxa > 0 ? `${taxa}%` : '—'}</td>
                            <td style={{textAlign:'right', fontWeight:700, color: cor}}>{m !== null ? `${m}%` : '—'}</td>
                            <td style={{textAlign:'right', color:'#555'}}>{liquido ? formatCurrency(liquido) : '—'}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {/* Calculadora de preço sugerido */}
                  {parseFloat(form.custo) > 0 && (
                    <div style={{marginTop:10, paddingTop:10, borderTop:'1px solid #eee'}}>
                      <div style={{display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}>
                        <span style={{fontSize:12, color:'#555'}}>Quero margem de</span>
                        <input
                          type="number" min="1" max="99" step="1"
                          value={margemAlvo}
                          onChange={e => setMargemAlvo(e.target.value)}
                          style={{width:56, padding:'4px 6px', border:'1px solid #ddd', borderRadius:6, fontSize:13, fontWeight:700, textAlign:'center'}}
                        />
                        <span style={{fontSize:12, color:'#555'}}>% → preços sugeridos:</span>
                      </div>
                      <div style={{display:'flex', flexWrap:'wrap', gap:6, marginTop:8}}>
                        {[
                          { label: 'Dinheiro', taxa: 0 },
                          ...taxas.map(t => ({ label: t.nome, taxa: parseFloat(t.taxa) || 0 })),
                        ].map(({ label, taxa }, idx) => {
                          const sug = calcPrecoSugerido(form.custo, margemAlvo, taxa);
                          return sug ? (
                            <div key={idx} style={{background:'white', border:'1px solid #ddd', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer'}}
                              onClick={() => setForm({...form, preco: sug.toFixed(2)})}
                              title={`Clique para usar este preço`}>
                              <span style={{color:'#888'}}>{label}: </span>
                              <strong style={{color:'#e67e22'}}>{formatCurrency(sug)}</strong>
                            </div>
                          ) : null;
                        })}
                      </div>
                      <div style={{fontSize:11, color:'#aaa', marginTop:4}}>Clique em um valor para aplicá-lo ao preço</div>
                    </div>
                  )}
                </div>
              )}

              {/* Vínculo com estoque */}
              <div className="form-group">
                <label>Controle de estoque</label>
                <select value={form.tipo_estoque} onChange={e => setForm({...form, tipo_estoque: e.target.value, insumo_id: ''})}>
                  <option value="revenda">Revenda (baixa direta em um insumo)</option>
                  <option value="fabricado">Fabricado (baixa via ficha técnica)</option>
                </select>
              </div>

              {form.tipo_estoque === 'revenda' && (
                <div className="form-group">
                  <label>Insumo de estoque (revenda)</label>
                  <select value={form.insumo_id} onChange={e => setForm({...form, insumo_id: e.target.value})} required>
                    <option value="">— selecione —</option>
                    {insumos.map(i => (
                      <option key={i.id} value={i.id}>{i.nome} ({i.qtd_estoque} {i.unidade})</option>
                    ))}
                  </select>
                </div>
              )}

              {form.tipo_estoque === 'fabricado' && modal !== 'novo' && (
                <div style={{background:'#f3e8ff', border:'1px solid #c4b5fd', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:13, color:'#6b21a8'}}>
                  🔬 Salve o produto e clique em <strong>"Ficha"</strong> na tabela para configurar os insumos consumidos por unidade.
                </div>
              )}

              {form.tipo_estoque === 'fabricado' && modal === 'novo' && (
                <div style={{background:'#f3e8ff', border:'1px solid #c4b5fd', borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:13, color:'#6b21a8'}}>
                  🔬 Após salvar, use o botão <strong>"Ficha"</strong> na tabela para definir os insumos consumidos.
                </div>
              )}

              <div className="form-group">
                <label>Tags</label>
                <input value={form.tags} onChange={e => setForm({...form, tags: e.target.value})} placeholder="Ex: carne, queijo, especial" />
              </div>
              <div className="form-group">
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={form.exibir_cardapio}
                    onChange={e => setForm({ ...form, exibir_cardapio: e.target.checked })}
                    style={{ width: 18, height: 18 }}
                  />
                  Exibir no cardápio
                </label>
                <small style={{ color: '#888' }}>Desmarque para produtos internos (uso da pastelaria / baixa de estoque) que não devem aparecer no cardápio público.</small>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModal(null)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Ficha Técnica */}
      {fichaModal && (
        <div className="modal-overlay" onClick={() => setFichaModal(null)}>
          <div className="modal-content" style={{maxWidth: 560}} onClick={e => e.stopPropagation()}>
            <div style={{marginBottom:16}}>
              <h2 style={{margin:0}}>🔬 Ficha Técnica</h2>
              <div style={{color:'#888', fontSize:13, marginTop:4}}>{fichaModal.emoji} {fichaModal.nome}</div>
            </div>

            {fichaLoading ? (
              <div style={{textAlign:'center', padding:24, color:'#888'}}>Carregando...</div>
            ) : (
              <form onSubmit={salvarFicha}>
                <div style={{marginBottom:8, fontSize:13, color:'#555'}}>
                  Insumos consumidos <strong>por unidade vendida</strong>:
                </div>

                {fichaItems.map((item, idx) => (
                  <div key={idx} className="form-row" style={{alignItems:'center', marginBottom:8}}>
                    <div className="form-group" style={{flex:2, marginBottom:0}}>
                      <select
                        value={item.insumo_id}
                        onChange={e => atualizarLinhaFicha(idx, 'insumo_id', e.target.value)}
                        required
                      >
                        <option value="">— insumo —</option>
                        {insumos.map(i => (
                          <option key={i.id} value={String(i.id)}>{i.nome} ({i.unidade})</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group" style={{flex:1, marginBottom:0}}>
                      <input
                        type="number" step="0.001" placeholder="Qtd"
                        value={item.quantidade}
                        onChange={e => atualizarLinhaFicha(idx, 'quantidade', e.target.value)}
                        required
                      />
                    </div>
                    <button
                      type="button"
                      onClick={() => removerLinhaFicha(idx)}
                      style={{background:'none', border:'none', color:'#e74c3c', fontSize:18, cursor:'pointer', flexShrink:0, padding:'0 4px'}}
                    >×</button>
                  </div>
                ))}

                <button type="button" className="btn btn-secondary btn-sm" onClick={adicionarLinhaFicha} style={{marginBottom:16}}>
                  + Adicionar insumo
                </button>

                {fichaItems.length > 0 && (
                  <div style={{background:'#f8f9fa', borderRadius:8, padding:'8px 12px', marginBottom:16, fontSize:13}}>
                    Custo estimado por unidade: <strong style={{color:'#e67e22'}}>{formatCurrency(custoFicha)}</strong>
                  </div>
                )}

                <div className="modal-actions">
                  <button type="button" className="btn btn-secondary" onClick={() => setFichaModal(null)}>Cancelar</button>
                  <button type="submit" className="btn btn-primary">Salvar Ficha</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Modal Gerenciar Categorias */}
      {modalCat && (
        <div className="modal-overlay" onClick={() => setModalCat(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h2>⚙ Categorias do Cardápio</h2>
            {erroCat && <div className="alert alert-danger">{erroCat}</div>}

            <form onSubmit={salvarNovaCategoria} className="cat-nova-form">
              <EmojiPicker value={catForm.emoji} onChange={v => setCatForm({ ...catForm, emoji: v })} />
              <input
                value={catForm.nome}
                onChange={e => setCatForm({ ...catForm, nome: e.target.value })}
                placeholder="Nova categoria (ex: Bebidas)"
                required
              />
              <input
                type="number"
                value={catForm.ordem}
                onChange={e => setCatForm({ ...catForm, ordem: e.target.value })}
                placeholder="Ordem"
                title="Ordem de exibição"
                style={{ width: 72 }}
              />
              <button type="submit" className="btn btn-primary btn-sm">+ Adicionar</button>
            </form>

            <div className="cat-lista">
              {categorias.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 24, color: '#aaa' }}>
                  Nenhuma categoria cadastrada.
                </div>
              ) : categorias.map(c => (
                <div key={c.id} className="cat-item">
                  {catEditId === c.id ? (
                    <form onSubmit={salvarEdicaoCategoria} className="cat-edit-form">
                      <EmojiPicker value={catEdit.emoji} onChange={v => setCatEdit({ ...catEdit, emoji: v })} />
                      <input value={catEdit.nome} onChange={e => setCatEdit({ ...catEdit, nome: e.target.value })} required autoFocus />
                      <input type="number" value={catEdit.ordem} onChange={e => setCatEdit({ ...catEdit, ordem: e.target.value })} title="Ordem" style={{ width: 60 }} />
                      <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, whiteSpace: 'nowrap' }} title="Categoria ativa">
                        <input type="checkbox" checked={catEdit.ativa} onChange={e => setCatEdit({ ...catEdit, ativa: e.target.checked })} />
                        Ativa
                      </label>
                      <button type="submit" className="btn btn-sm btn-primary">Salvar</button>
                      <button type="button" className="btn btn-sm btn-secondary" onClick={() => setCatEditId(null)}>Cancelar</button>
                    </form>
                  ) : (
                    <>
                      <span className="cat-nome">
                        {c.emoji} {c.nome}{' '}
                        <small>({c.total_produtos} produto{c.total_produtos !== 1 ? 's' : ''})</small>
                        {c.ativa === 0 && <span className="badge badge-secondary" style={{ marginLeft: 6, fontSize: 10 }}>inativa</span>}
                      </span>
                      <div className="cat-acoes">
                        <button type="button" className="btn-icon" title="Editar" onClick={() => iniciarEdicaoCategoria(c)}>✏️</button>
                        <button type="button" className="btn-icon" title="Remover" onClick={() => removerCategoria(c)}>🗑️</button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>

            <div className="modal-actions" style={{ marginTop: 16 }}>
              <button className="btn btn-secondary" onClick={() => setModalCat(false)}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
